import { Component, Injector, OnInit } from "@angular/core";
import { BaseRoutedComponent } from "@common/ux/base-routed.component";

@Component({
    selector: "adapt-analyse-catchups-page",
    templateUrl: "./analyse-catchups-page.component.html",
    standalone: false,
})
export class AnalyseCatchupsPageComponent extends BaseRoutedComponent implements OnInit {
    constructor(injector: Injector) {
        super(injector);
    }

    public ngOnInit() {
        super.notifyActivated();
    }
}
